import { GtmEvents } from '@/gtm/gtm-events';

export class BannersGtmEvents extends GtmEvents {
  eventCategory = 'СобытияБаннеры';

  showBanner({ slotName, hostUrl, redirectUrl, imageUrl, index }) {
    return this.gtmEvent({
      eventAction: `БаннерПоказ_${slotName}`,
      eventLabel: this._getBannerEventLabel({ imageUrl, hostUrl, redirectUrl, index }),
    });
  }

  clickBanner({ slotName, text, hostUrl, redirectUrl, imageUrl, index }) {
    return this.gtmEvent({
      eventAction: `БаннерКлик_${slotName}_${text || 'Баннер'}`,
      eventLabel: this._getBannerEventLabel({ imageUrl, hostUrl, redirectUrl, index }),
    });
  }

  _getBannerEventLabel({ imageUrl, hostUrl, redirectUrl, index }) {
    const currentPage = window?.location?.pathname;

    const eventLabel = [
      imageUrl,
      `${hostUrl || currentPage}-->${redirectUrl || currentPage}`,
    ];

    index != null && eventLabel.push(index + 1);

    return eventLabel.join('|');
  }
}

export const bannersGtmEvents = new BannersGtmEvents();
